import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    label: {
      fontStyle: 'normal',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '2px',
      borderRadius: '3px',
    },
    employment: {
      color: legacyColors.white,
      backgroundColor: legacyColors.blue,
    },
    employmentDetails: {
      color: legacyColors.white,
      backgroundColor: legacyColors.green,
    },
    newEmployment: {
      color: legacyColors.black,
      backgroundColor: legacyColors.yellow,
    },
  };
};
